import { render, staticRenderFns } from "./LindaFriedComponent.vue?vue&type=template&id=b14246d4"
import script from "./LindaFriedComponent.vue?vue&type=script&lang=js"
export * from "./LindaFriedComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports